module.exports = __webpack_public_path__ + "static/media/about-one-sm.0d80ffab.webp";